import { Navigate, Route, Routes as Router } from "react-router-dom";

import Reports from "../pages/Reports";
import { REPORTS, SUMMARY_REPORT } from "./routes";
import SummaryReports from "pages/SummaryReports";

const AppRouter = () => (
  <Router>
    <Route path="/" element={<Navigate to="reports" />} />
    <Route path={REPORTS} element={<Reports />} />
    <Route path={SUMMARY_REPORT} element={<SummaryReports />} />
  </Router>
);

export default AppRouter;
